module.exports = __webpack_public_path__ + "media/man7.685a2c81.wav";